import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function EstimatedYield({ selectedProperty }) {
  const { t } = useTranslation();
  const [rent, setRent] = useState('');
  const [expenses, setExpenses] = useState('');
  const [currency, setCurrency] = useState('THB'); // ค่าเริ่มต้น THB

  // แปลงราคาทรัพย์เป็นตัวเลข
  const priceNumberTHB = Number(selectedProperty.price.toString().replace(/,/g, '')) || 0;

  // อัตราแลกเปลี่ยน USD สมมติ 1 USD = 34 THB
  const rate = currency === 'USD' ? 34 : 1;

  // แปลงราคาทรัพย์ให้ตรงกับสกุลเงิน
  const priceNumber = priceNumberTHB / rate;

  // แปลง input rent & expenses ให้ตรงสกุลเงิน
  const monthlyRentNumber = Number(rent) || 0;
  const annualExpensesNumber = Number(expenses) || 0;

  // คำนวณรายได้ต่อปี (ตามสกุลเงินเดียวกัน)
  const annualIncome = monthlyRentNumber * 12;

  // คำนวณ Yield
  const grossYield = priceNumber > 0 ? ((annualIncome / priceNumber) * 100).toFixed(2) : '0.00';
  const netYield = priceNumber > 0 ? (((annualIncome - annualExpensesNumber) / priceNumber) * 100).toFixed(2) : '0.00';

  // แสดงผลตัวเลขในสกุลเงินเดียวกัน
  const priceDisplay = priceNumber.toLocaleString(undefined, { minimumFractionDigits: 2 });
  const monthlyRentDisplay = monthlyRentNumber.toLocaleString(undefined, { minimumFractionDigits: 2 });
  const annualExpensesDisplay = annualExpensesNumber.toLocaleString(undefined, { minimumFractionDigits: 2 });
  const currencySymbol = currency === 'USD' ? '$' : '฿';

  // สลับค่าเงิน
  const toggleCurrency = () => {
    // แปลงค่า rent & expenses ให้เป็นสกุลเงินใหม่
    const newCurrency = currency === 'THB' ? 'USD' : 'THB';
    const newRate = newCurrency === 'USD' ? 34 : 1;
    setRent(((monthlyRentNumber * rate) / newRate).toFixed(2));
    setExpenses(((annualExpensesNumber * rate) / newRate).toFixed(2));
    setCurrency(newCurrency);
  };

  return (
    <div style={{
      marginTop: '30px',
      padding: '15px 20px',
      maxWidth: '650px',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: '12px',
      backgroundColor: '#f9f9f9',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      color: '#1a2e35',
      textAlign: 'center',
    }}>
      <h3 style={{ fontSize: '1.3rem', fontWeight: '600', marginBottom: '10px' }}>
        {t("Estimated Yield")}
      </h3>

      <p style={{ margin: '6px 0', fontSize: '1rem' }}>
         <strong>{t("Property Price")}:</strong> {priceDisplay} {currencySymbol}
      </p>

      {/* Input Rent */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', marginBottom: '10px' }}>
        <label>{t("Monthly Rent")}:</label>
        <input
          type="number"
          value={rent}
          onChange={(e) => setRent(e.target.value)}
          style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #ccc', width: '120px' }}
        />
        <span>{currencySymbol}</span>
      </div>

      {/* Input Expenses */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px', marginBottom: '15px' }}>
        <label>{t("Annual Expenses")}:</label>
        <input
          type="number"
          value={expenses}
          onChange={(e) => setExpenses(e.target.value)}
          style={{ padding: '5px 10px', borderRadius: '6px', border: '1px solid #ccc', width: '120px' }}
        />
        <span>{currencySymbol}</span>
      </div>

      {/* ปุ่มสลับค่าเงิน */}
      <button
        onClick={toggleCurrency}
        style={{
          padding: '8px 20px',
          marginBottom: '15px',
          cursor: 'pointer',
          borderRadius: '25px',
          border: 'none',
          background: 'linear-gradient(90deg, #4facfe 0%, #00f2fe 100%)',
          color: '#fff',
          fontWeight: '600',
          fontSize: '0.95rem',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        }}
      >
        {currency === 'THB' ? 'Switch to USD $' : 'Switch to THB ฿'}
      </button>

      {/* Yield Output */}
      <p style={{ margin: '6px 0', fontSize: '1rem' }}>
        🪙 <strong>{t("Gross Yield")}:</strong> {grossYield}%
      </p>
      <p style={{ margin: '6px 0', fontSize: '1rem' }}>
        ⏱️ <strong>{t("Net Yield")}:</strong> {netYield}%
      </p>
      <p style={{ marginTop: '10px', fontSize: '0.85rem', color: '#555' }}>
        {t("Based on monthly rent and annual expenses")}
      </p>
    </div>
  );
}

export default EstimatedYield;
